// Side-by-side note-gen inputs the package cannot reach: template-cache
// reads, the chronicle filename and the section count. Required members,
// fail-loud.

/** What `streamNoteCandidatesAction` threads through and never reads. */
export type NoteGenerationTimingsHandle = { startTime: number };

/**
 * The three fields the side-by-side path passes into note-generation timing.
 * The app's wider context type accepts this both ways, so the wiring binds
 * the app functions with no cast.
 */
export type SideBySideNoteGenerationContext = {
  sessionId: string;
  is_pinned_template: boolean;
  is_starter_pack_template: boolean;
};

export interface SideBySideNoteGenConfig {
  noteGenerationTracking: {
    start: (ctx: SideBySideNoteGenerationContext) => NoteGenerationTimingsHandle;
    /**
     * Success and failure share this call. The wiring attaches
     * `createAllCandidatesFailedError()` when `isSuccess` is false — the
     * package does not import the telemetry error.
     */
    finish: (
      ctx: SideBySideNoteGenerationContext,
      timings: NoteGenerationTimingsHandle,
      isSuccess: boolean
    ) => void;
  };
  templates: {
    getName: (templateId: string | null | undefined) => string | undefined;
    isPinned: (templateId: string | null | undefined) => boolean;
    isSectional: (templateId: string | null | undefined) => boolean;
    isStarter: (templateId: string | null | undefined) => boolean;
  };
  /** Chronicle device filename. Absent for mic and upload sessions. */
  getChronicleDeviceFileNameForSession: (sessionId: string) => string | undefined;
  /** `# ` headings in the generated markdown. 0 means the note is not sectional. */
  countMarkdownSections: (markdown: string) => number;
}

let config: SideBySideNoteGenConfig | null = null;

export const configureSideBySideNoteGen = (next: SideBySideNoteGenConfig): void => {
  config = next;
};

/** Fail loudly on unconfigured use — never silently degrade. */
export const getSideBySideNoteGenConfig = (): SideBySideNoteGenConfig => {
  if (!config) {
    throw new Error(
      '[session/data] side-by-side note-gen not configured — app bootstrap must call configureSideBySideNoteGen() ' +
        '(see src/composition/hosts/session/session-data-wiring.ts); tests exercising the real actions must configure a test double first.'
    );
  }
  return config;
};
